<template>
  <date-picker-erp
    :value="_value"
    placeholder="选择日期时间"
    time-type="datetime"
    value-format="YYYY-MM-DD HH:mm:ss"
    v-bind="props"
    @change="onChange"
  ></date-picker-erp>
</template>

<script>
import storeMixins from '../store-mixins';

export default {
  mixins: [storeMixins],
  props: ['props', 'tipRule', 'value'],
  computed: {
    key() {
      return this.props.name;
    },
    tips() {
      return this.tipRule || [];
    },
    hasTips() {
      return this.tips.length;
    },
    _value() {
      return this.alibabaForm[this.key];
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {};
      newFormFields[this.key] = v;
      this.updateAlibabaForm(newFormFields);
    },
  },
};
</script>

<style></style>